const ThemeConstants = {
  // Color Variables
  PRIMARY_MAIN_COLOR: "#0B0E23",
  SECONDARY_MAIN_COLOR: "#454A6B",
  BUTTON_MAIN_COLOR: "#F8981C",
  WHITE_COLOR: "#ffffff", //Never change this value as it is used for Fixed elements(like text on images in all themes)
  BLACK_COLOR: "#14142B", //Never change this value as it is used for Fixed elements
  BLACK_COLOR_VARIANT1: "#2d2d39",
  BLACK_COLOR_VARIANT2: "#1D1D25",
  OFF_WHITE_COLOR: "#F5F6F8",
  LIGHT_BLUE_COLOR: "#dff3ff",
  LIGHT_GREY_COLOR: "#707070",
  LIGHT_GREY_COLOR_VARIANT1: "#89909A",
  LIGHT_GREY_COLOR_VARIANT5: "#CED3D9",
  LIGHT_GREY_COLOR_VARIANT7: "#EFF0F7",
  ZAGG_RED: "#AA1A2D",
  // New theme Color Variables
  BODY_COLOR: "#4E4B66",
  BLACK_COLOR_V1: "#14142B",
  BLACK_COLOR_V2: "#2B2742",
  GRAY_COLOR_v1: "#4E4B66",
  GRAY_COLOR_v2: "#A0A3BD",
  LABEL_COLOR: "#6E7191",
  // Font Weight
  FONTWEIGHT_LIGHT: 300,
  FONTWEIGHT_REGULAR: 400,
  FONTWEIGHT_MEDIUM: 500,
  FONTWEIGHT_SEMIBOLD: 600,
  FONTWEIGHT_BOLD: 700,
  // Breakpoints
  XS: 320,
  SM: 600,
  MD: 768,
  EM: 1024,
  LG: 1280,
  XL: 1440,
  // Text Transform
  TEXTTRANSFORMUPPERCASE: "uppercase",
  TEXTTRANSFORMCAPITALIZECASE: "capitalize",
  TEXTTRANSFORMLOWERCASE: "lowercase",

  /***== New Design System Implementation ==***/
  /*  Typography */
  TYPOGRAPHY: {
    HEADING: {
      WEB_LARGE: {
        FONT: {
          SIZE_LG: "78px",
          LG_LINE_HEIGHT: "0.92",
          SIZE_EM: "52px",
          EM_LINE_HEIGHT: "0.92",
          SIZE_SM: "38px",
          SM_LINE_HEIGHT: "0.92",
        },
        MARGIN: {
          SMTOP: "10px",
          LGTOP: "12px",
          SMBOTTOM: "10px",
          LGBOTTOM: "12px",
        },
      },
      H1LARGE: {
        FONT: {
          SIZE_LG: "56px",
          LG_LINE_HEIGHT: "0.95",
          SIZE_EM: "46px",
          EM_LINE_HEIGHT: "0.95",
          SIZE_SM: "36px",
          SM_LINE_HEIGHT: "0.95",
        },
        MARGIN: {
          SMTOP: "10px",
          LGTOP: "12px",
          SMBOTTOM: "10px",
          LGBOTTOM: "12px",
        },
      },
      H1: {
        FONT: {
          SIZE_LG: "56px",
          LG_LINE_HEIGHT: "0.95",
          SIZE_EM: "46px",
          EM_LINE_HEIGHT: "0.95",
          SIZE_SM: "36px",
          SM_LINE_HEIGHT: "0.95",
        },
        MARGIN: {
          SMTOP: "10px",
          LGTOP: "12px",
          SMBOTTOM: "10px",
          LGBOTTOM: "12px",
        },
      },
      H2: {
        FONT: {
          SIZE_LG: "36px",
          LG_LINE_HEIGHT: "1.1",
          SIZE_EM: "32px",
          EM_LINE_HEIGHT: "1.1",
          SIZE_SM: "30px",
          SM_LINE_HEIGHT: "1.1",
        },
        MARGIN: {
          SMTOP: "10px",
          LGTOP: "12px",
          SMBOTTOM: "10px",
          LGBOTTOM: "12px",
        },
      },
      H3: {
        FONT: {
          SIZE_LG: "28px",
          LG_LINE_HEIGHT: "1.1",
          SIZE_EM: "28px",
          EM_LINE_HEIGHT: "1.1",
          SIZE_SM: "23px",
          SM_LINE_HEIGHT: "1.1",
        },
        MARGIN: {
          SMTOP: "10px",
          LGTOP: "12px",
          SMBOTTOM: "10px",
          LGBOTTOM: "12px",
        },
      },
      H4: {
        FONT: {
          SIZE_LG: "23px",
          LG_LINE_HEIGHT: "1.15",
          SIZE_EM: "23px",
          EM_LINE_HEIGHT: "1.15",
          SIZE_SM: "19px",
          SM_LINE_HEIGHT: "1.15",
        },
        MARGIN: {
          SMTOP: "10px",
          LGTOP: "12px",
          SMBOTTOM: "10px",
          LGBOTTOM: "12px",
        },
      },
      H5: {
        FONT: {
          SIZE_LG: "19px",
          LG_LINE_HEIGHT: "1.2",
          SIZE_EM: "19px",
          EM_LINE_HEIGHT: "1.2",
          SIZE_SM: "17px",
          SM_LINE_HEIGHT: "1.2",
        },
        MARGIN: {
          SMTOP: "10px",
          LGTOP: "12px",
          SMBOTTOM: "10px",
          LGBOTTOM: "12px",
        },
      },
      H6: {
        FONT: {
          SIZE_LG: "17px",
          LG_LINE_HEIGHT: "1.2",
          SIZE_EM: "17px",
          EM_LINE_HEIGHT: "1.2",
          SIZE_SM: "17px",
          SM_LINE_HEIGHT: "1.2",
        },
        MARGIN: {
          SMTOP: "10px",
          LGTOP: "12px",
          SMBOTTOM: "10px",
          LGBOTTOM: "12px",
        },
      },
      H7: {
        FONT: {
          SIZE_LG: "12px",
          LG_LINE_HEIGHT: "1.5",
          SIZE_EM: "12px",
          EM_LINE_HEIGHT: "1.5",
          SIZE_SM: "12px",
          SM_LINE_HEIGHT: "1.5",
        },
        MARGIN: {
          SMTOP: "10px",
          LGTOP: "12px",
          SMBOTTOM: "10px",
          LGBOTTOM: "12px",
        },
      },
    },
    PARAGRAPH: {
      P1: {
        FONT: {
          SIZE_LG: "18px",
          LG_LINE_HEIGHT: "1.65",
          SIZE_EM: "18px",
          EM_LINE_HEIGHT: "1.65",
          SIZE_SM: "18px",
          SM_LINE_HEIGHT: "1.65",
        },
        MARGIN: {
          SMTOP: "10px",
          LGTOP: "12px",
          SMBOTTOM: "10px",
          LGBOTTOM: "12px",
        },
      },
      P2: {
        FONT: {
          SIZE_LG: "16px",
          LG_LINE_HEIGHT: "1.65",
          SIZE_EM: "16px",
          EM_LINE_HEIGHT: "1.65",
          SIZE_SM: "16px",
          SM_LINE_HEIGHT: "1.65",
        },
        MARGIN: {
          SMTOP: "10px",
          LGTOP: "12px",
          SMBOTTOM: "10px",
          LGBOTTOM: "12px",
        },
      },
      P3: {
        FONT: {
          SIZE_LG: "15px",
          LG_LINE_HEIGHT: "1.6",
          SIZE_EM: "15px",
          EM_LINE_HEIGHT: "1.6",
          SIZE_SM: "15px",
          SM_LINE_HEIGHT: "1.6",
        },
        MARGIN: {
          SMTOP: "10px",
          LGTOP: "12px",
          SMBOTTOM: "10px",
          LGBOTTOM: "12px",
        },
      },
      P4: {
        FONT: {
          SIZE_LG: "13.5px",
          LG_LINE_HEIGHT: "1.5",
          SIZE_EM: "13.5px",
          EM_LINE_HEIGHT: "1.5",
          SIZE_SM: "12px",
          SM_LINE_HEIGHT: "1.5",
        },
        MARGIN: {
          SMTOP: "10px",
          LGTOP: "12px",
          SMBOTTOM: "10px",
          LGBOTTOM: "12px",
        },
      },
    },
    LABEL: {
      LABEL1: {
        FONT: {
          SIZE_LG: "12px",
          LG_LINE_HEIGHT: "1.5",
          SIZE_EM: "12px",
          EM_LINE_HEIGHT: "1.5",
          SIZE_SM: "12px",
          SM_LINE_HEIGHT: "1.5",
        },
        PADDING: {
          SMTOP: "10px",
          SMBOTTOM: "10px",
          LGTOP: "12px",
          LGBOTTOM: "12px",
        },
      },
      LABEL2: {
        FONT: {
          SIZE_LG: "12px",
          LG_LINE_HEIGHT: "1.5",
          SIZE_EM: "12px",
          EM_LINE_HEIGHT: "1.5",
          SIZE_SM: "12px",
          SM_LINE_HEIGHT: "1.5",
        },
        PADDING: {
          SMTOP: "10px",
          SMBOTTOM: "10px",
          LGTOP: "12px",
          LGBOTTOM: "12px",
        },
      },
      LABEL3: {
        FONT: {
          SIZE_LG: "16px",
          LG_LINE_HEIGHT: "1.25",
          SIZE_EM: "16px",
          EM_LINE_HEIGHT: "1.25",
          SIZE_SM: "14px",
          SM_LINE_HEIGHT: "1.25",
        },
        PADDING: {
          SMTOP: "10px",
          SMBOTTOM: "10px",
          LGTOP: "12px",
          LGBOTTOM: "12px",
        },
      },
    },
  },
  ELEMENT: {
    TEXTBOX: {
      BORDER_RADIUS: "5px",
      PADDING: {
        sm: "22px 12px 4px 10px",
        md: "22px 12px 4px 10px",
      },
      PADDINGV2: {
        sm: "25px 12px 12px 12px",
        md: "25px 12px 12px 12px",
      },
      PADDINGV3: {
        sm: "20px 12px 15px 12px",
        md: "20px 12px 15px 12px",
      },
      FONT: {
        SIZE_LG: "14px",
        LG_LINE_HEIGHT: "24px",
        SIZE_EM: "14px",
        EM_LINE_HEIGHT: "24px",
        SIZE_SM: "12px",
        SM_LINE_HEIGHT: "20px",
      },
      LABEL_GAP: "0px 0px 0px 20px",
    },
    BUTTON: {
      BORDER_RADIUS: "8px",
      MEDIUM_HEIGHT: "47px",
      SMALL_HEIGHT: "38px",
      LARGE_HEIGHT: "63px",
      XLARGE_HEIGHT: "66px",
      MIN_WIDTH: "160px",
      MIN_WIDTH_SMALL: "90px",
      CTA_XS_HEIGHT: "25px",
      PADDING: {
        sm: "9px 16px",
        md: "12px 24px",
        lg: "20px 32px",
        xl: "20px 32px",
      },
      MARGIN: {
        TOP: "12px",
        RIGHT: "12px",
        BOTTOM: "12px",
        LEFT: "0px",
        SMMARGIN: "10px 10px 10px 0px",
        MDMARGIN: "10px 10px 10px 0px",
      },
      FONT: {
        SM: "14px",
        MD: "16px",
        LG: "16px",
        XL: "16px",
      },
    },
    SELECT: {
      BORDER_RADIUS: "5px",
      HEIGHT: "60px",
      PADDING: {
        sm: "14px 12px 14px 12px",
        md: "14px 12px 14px 12px",
      },
    },
    ACCORDIAN: {
      BORDER_RADIUS: "5px",
      BORDER: "2px",
      PADDING1: "6px 24px 6px 24px",
      PADDING2: "16px 24px 16px 24px",
      MARGINBOTTOM: "32px",
      PADDING: {
        sm: "7px 16px",
        md: "7px 15px 3px 18px",
        lg: "17px 50px 16px 50px",
        xl: "17px 50px 16px 50px",
      },
    },
    CARD: {
      TYPE_1: {
        BORDER_RADIUS: "8px",
        PADDING_CONTENT: "12px 20px 20px 20px",
        PADDING_IMAGE: "12px 20px 20px 20px",
        ELEVATION4: "0px 10px 15px 0px rgba(0, 0, 0, 0.03);",
        GRADIENT: "linear-gradient(0deg, #000 0%, rgba(0, 0, 0, 0.00) 100%)",
      },
    },
    TAB: {
      FONT: {
        SIZE_LG: "16px",
        LG_LINE_HEIGHT: "20px",
        SIZE_EM: "16px",
        EM_LINE_HEIGHT: "20px",
        SIZE_SM: "14px",
        SM_LINE_HEIGHT: "18px",
      },
      PADDING: {
        sm: "12px 24px",
        md: "14px 32px",
        lg: "16px 48px",
        xl: "20px 32px",
      },
      PANEL_PADDING: {
        sm: "10px 15px 0px 0px",
        md: "10px 15px 0px 20px",
        lg: "10px 15px 0px 0px",
        xl: "10px 15px 0px 0px",
      },
      TAB_GAP: "10px",
      BORDER_RADIUS: "20px 20px 0px 0px", //it's for indivisual-2 Tabs only
      BORDER_RADIUS1: "20px 20px 0px 0px", //it's for Wrapper of Tabs only
      INDICATOR_HEIGHT: "4px",
    },
    CHIP: {
      FONT: {
        SIZE_LG: "16px",
        LG_LINE_HEIGHT: "20px",
        SIZE_EM: "16px",
        EM_LINE_HEIGHT: "20px",
        SIZE_SM: "14px",
        SM_LINE_HEIGHT: "18px",
      },
    },
  },
  OVERYLAY: {
    EDITOVERLAY: "50, 130, 250, 0.9",
    BGOVERLAY: "255, 255, 255, 0.3",
    CARDOVERLAY: "0, 0,0, 0.2",
    CARD_GRADIENT: "linear-gradient(185deg,rgba(0,0,0,0) 30%,rgba(0,0,0,.9) 70%)",
    /* Hero scrim darkens along the X axis, behind the left-aligned hero copy. Kept separate
       from CARD_GRADIENT (bottom-up, shared by ~11 card/banner prelems) so the two can be
       tuned independently. */
    HERO_SCRIM:
      "linear-gradient(90deg,rgba(8,11,30,.96) 0%,rgba(9,12,34,.8) 42%,rgba(13,18,52,.32) 100%)",
    PINSTRIPE:
      "repeating-linear-gradient(118deg, rgba(255,255,255,.04) 0px, rgba(255,255,255,.04) 2px, transparent 2px, transparent 62px)",
    /* Dark navy section grounds from the design prototype: full-width band (stats) and the
       half-width text panel (athlete spotlight). Decorative overlay on the Secondary (deep navy)
       type only - Secondary itself stays the solid #0A0D24. */
    BAND_GRADIENT: "linear-gradient(135deg,#0a0d24,#11142f 55%,#1f234c)",
    PANEL_GRADIENT: "linear-gradient(135deg,#11142f,#1f234c)",
  },
  RADIUS: {
    VALUE1: "15px",
    VALUE2: "10px",
    BUTTON: "8px",
    CHIP: "100px",
    CARD_SMALL: "12px",
    CARD: "16px",
    CARD_LARGE: "20px",
  },
  /* Elevation tokens: rest / hover / deep (video + feature) */
  SHADOW: {
    REST: "0 2px 12px rgba(10, 13, 36, 0.07)",
    HOVER: "0 18px 40px rgba(10, 13, 36, 0.15)",
    DEEP: "0 30px 70px rgba(0, 0, 0, 0.5)",
  },

  /* Prelem Type 1 PRIMARY (White surface, navy ink) - Theme Builder: Primary #FFFFFF */
  PRIMARY_PRELEM: {
    BACKGROUND: "#FFFFFF",
    TITLE: "#12152E",
    TITLE_V2: "#1F1450",
    PARAGRAPH: "#5B6079",
    LABEL: "#5B6079",
    LINE: "#E6E8F0",
    LINK: "#A85A00",
    ACCENT_TEXT: "#A85A00",
    ANCHOR: "#1F234C",
    ANCHOR_HOVER: "#A85A00",
    TEXTURE:
      "repeating-linear-gradient(118deg, rgba(10,13,36,.03) 0px, rgba(10,13,36,.03) 2px, transparent 2px, transparent 62px)",
    FOCUS_RING: "#1F234C",
    BUTTON: {
      /* Dark ink on amber, not white: #FFFFFF on #F8981C is ~2.2:1 and fails WCAG AA for
         button text, while #0B0E23 on #F8981C is ~8:1. Hover lightens the amber instead of
         inverting to white, which had the same contrast problem in reverse. */
      VARIANT1: {
        COLOR: "#0A0D24",
        COLOR_HOVER: "#0A0D24",
        BACKGROUND_COLOR: "#F8981C",
        BACKGROUND_COLOR_HOVER: "#FFA940",
        BORDER: "solid 2px  #F8981C",
        BORDER_HOVER: "solid 2px  #FFA940",
      },
      VARIANT2: {
        COLOR: "#1F234C",
        COLOR_HOVER: "#FFFFFF",
        BACKGROUND_COLOR: "transparent",
        BACKGROUND_COLOR_HOVER: "#1F234C",
        BORDER: "solid 2px  #1F234C",
        BORDER_HOVER: "solid 2px  #1F234C",
      },
      VARIANT3: {
        COLOR: "#A85A00",
        COLOR_HOVER: "#0A0D24",
        BACKGROUND_COLOR: "transparent",
        BACKGROUND_COLOR_HOVER: "#F8981C",
        BORDER: "solid 2px  #A85A00",
        BORDER_HOVER: "solid 2px  #F8981C",
      },
      VARIANT4: {
        COLOR: "#3C3C3C",
        COLOR_HOVER: "#A85A00",
        BACKGROUND_COLOR: "transparent",
        BACKGROUND_COLOR_HOVER: "transparent",
        BORDER: "solid 2px  transparent",
        BORDER_HOVER: "solid 2px  transparent",
      },
      VARIANT5: {
        COLOR: "#FFFFFF",
        COLOR_HOVER: "#0A0D24",
        BACKGROUND_COLOR: "#0B0E23",
        BACKGROUND_COLOR_HOVER: "#F8981C",
        BORDER: "solid 1px  transparent",
        BORDER_HOVER: "solid 1px  transparent",
      },
    },
    INPUT: {
      PLACEHOLDER: "#EFF0F6",
      TEXT: "#14142B",
      TEXT_ACTIVE: "#14142B",
      LABEL: "#5B6079",
      BORDER: "solid 2px transparent",
      BORDER_ACTIVE: "solid 2px #14142B",
      BORDER_ERROR: "solid 2px #F33E41",
      BORDER_SUCCESS: "solid 2px #0FA069",
      BACKGROUND_FOCUSED: "#fff",
      BACKGROUND_ERROR: "#FFEBEE",
      BACKGROUND_ERROR_TEXT: "#F33E41",
      BACKGROUND_SUCCESS: "#DEF5D9",
      BACKGROUND_SUCCESS_TEXT: "#0FA069",
      DISABLED: "#EFF0F6",
    },
    SELECT: {
      PLACEHOLDER: "#EFF0F6", //Selectbox bg
      LABEL: "#6E7191", //animated tex of focus
      TEXT: "#6E7191", //dropdownlist popup default text
      TEXT_HOVER: "#14142B", //dropdownlist popup hover text color
      TEXT_SELECTED: "#14142B", //dropdownlist selected text color
      TEXT_BACKGROUND_HOVER: "#FCFCFC", //dropdownlist popup hover text background
      BORDER: "solid 2px transparent",
      BORDER_ACTIVE: "solid 2px #14142B", //focused border color
      ICON_MARGIN: "0px 15px 0px 0px",
      POPUPOVER_OPEN: {
        PADDING: {
          sm: "14px 22px 14px 22px",
          md: "14px 22px 14px 22px",
        },
        BORDER_RADIUS: "20px",
      },
    },
    CHECKBOX: {
      BOX_COLOR: "#14142B",
      BOX_COLOR_ACTIVE: "#F8981C",
    },
    SWITCH: {
      BOX_COLOR: "#6E7191",
      BOX_COLOR_ACTIVE: "#F8981C",
    },
    RADIO: {
      BOX_COLOR: "#14142B",
      BOX_COLOR_ACTIVE: "#F8981C",
      SIZE: "24px",
    },
    ACCORDIAN: {
      BACKGROUND: "#fff",
      COLOR: "#14142B",
      COLOR_HEADING: "#14142B",
      COLOR_PARAGRAPH: "#14142B",
      BORDER_COLOR: "#D9DBE9",
    },
    CARDS: {
      VARIANT1: {
        BACKGROUND: "#F4F5F9",
        ALTERNET_BACKGROUND: "#F7F7FC",
        TITLE: "#12152E",
        PARAGRAPH: "#5B6079",
        LABEL: "#5B6079",
        LINK: "#1F234C",
        BORDER_COLOR: "#D9DBE9",
        BORDER_COLOR_HOVER: "#14142B",
        BOX_SHADOW: "0px 10px 15px 0px rgba(0, 0, 0, 0.03)",
        BORDER_RADIUS: "16px",
        BORDER: "1px solid #CCCCCC",
        BORDER_HOVER: "1px solid #1a1a1a",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 21.9%, #000 100%)",
      },
      VARIANT2: {
        BACKGROUND: "#FEF3E2",
        ALTERNET_BACKGROUND: "#F8981C",
        TITLE: "#A85A00",
        PARAGRAPH: "#4E4B66",
        LABEL: "#5B6079",
        LINK: "#1F234C",
        BORDER_COLOR: "#C0C0C0",
        BORDER_COLOR_HOVER: "#14142B",
        BOX_SHADOW: "0px 10px 15px 0px rgba(0, 0, 0, 0.03)",
        BORDER_RADIUS: "20px",
        BORDER: "1px solid #CCCCCC",
        BORDER_HOVER: "1px solid #1a1a1a",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 21.9%, #000 100%)",
      },
      VARIANT3: {
        //used this for home page hero matches card
        BACKGROUND: "#F2F2F7",
        ALTERNET_BACKGROUND: "#E2E2EA",
        TITLE: "#020403",
        PARAGRAPH: "#4E4B66",
        LABEL: "#5B6079",
        LINK: "#1F234C",
        BORDER_COLOR: "rgba(0, 15, 225, 1)",
        BORDER_COLOR_HOVER: "linear-gradient(90deg, #a9aff6 0%, #E2E2EA 40%, #E2E2EA 100%)",
        BOX_SHADOW: "0px 10px 15px 0px rgba(0, 0, 0, 0.03)",
        BORDER_RADIUS: "20px",
        BORDER: "1px solid rgba(0, 0, 0, 0.30)",
        BORDER_HOVER: "1px solid rgba(0, 0, 0, 0.30)",
        BACKGROUND_GRADIENT: "linear-gradient(90deg, #a9aff6 0%, #E2E2EA 40%, #E2E2EA 100%)",
      },
      ECOM_CARD_BACKGROUND: "#fdfdfd",
      // Brand/emphasis card variant (KIWI-6221 ServiceCardFeatureGrid)
      BRAND_GRADIENT: "linear-gradient(140deg, #1F234C 0%, #003D79 100%)",
      CARD_ACCENT: "#B45309",
      BRAND_CARD_ACCENT: "#F59E0B",
      BRAND_ICON_CHIP: "255, 255, 255, 0.14",
      CARD_ICON_CHIP: "#1F234C",
      CARD_BOX_SHADOW: "0 2px 12px rgba(10, 13, 36, 0.07)",
      CARD_BOX_SHADOW_HOVER: "0 18px 40px rgba(10, 13, 36, 0.15)",
      ECOM_MASK_BACKGROUND: "#14142B",
    },
    ACCENTS: {
      VARIANT1: {
        BACKGROUND: "#F6F6F6",
        TITLE: "#14142B",
        PARAGRAPH: "#4E4B66",
        LABEL: "#5B6079",
        LINE: "#D9DBE9",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, #A8C5EB -57.3%, #FFF 100%)",
      },
      VARIANT2: {
        BACKGROUND: "#f2f2f2",
        TITLE: "#14142B",
        PARAGRAPH: "#4E4B66",
        LABEL: "#5B6079",
        LINE: "#D9DBE9",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, #A8C5EB -57.3%, #FFF 100%)",
      },
      VARIANT3: {
        BACKGROUND: "#FCE7C0",
        TITLE: "#14142B",
        PARAGRAPH: "#4E4B66",
        LABEL: "#5B6079",
        LINE: "#D9DBE9",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, #A8C5EB -57.3%, #FFF 100%)",
      },
      VARIANT4: {
        BACKGROUND: "#F9D9A0",
        TITLE: "#14142B",
        PARAGRAPH: "#4E4B66",
        LABEL: "#5B6079",
        LINE: "#D9DBE9",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, #A8C5EB -57.3%, #FFF 100%)",
      },
      VARIANT5: {
        BACKGROUND: "#F5C778",
        TITLE: "#14142B",
        PARAGRAPH: "#4E4B66",
        LABEL: "#4E4B66",
        LINE: "#D9DBE9",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, #A8C5EB -57.3%, #FFF 100%)",
      },
      VARIANT6: {
        BACKGROUND: "#F8981C",
        TITLE: "#0A0D24",
        PARAGRAPH: "#0A0D24",
        LABEL: "#0A0D24",
        LINE: "#FFFFFF",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, #A8C5EB -57.3%, #FFF 100%)",
      },
      VARIANT7: {
        BACKGROUND: "linear-gradient(180deg, #FAFAFA 0%, #F8F8F8 106.2%)",
        TITLE: "#B4881B",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINE: "#BB9C2B",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, #A8C5EB -57.3%, #FFF 100%)",
      },
    },
    TABLE: {
      VARIANT1: {
        BACKGROUND: "rgba(255, 255, 255, 1)",
        ROW_BACKGROUND: "rgba(168, 197, 235, 0.25)",
        BORDER_RADIUS: "10px",
        BOX_SHADOW: "0 2px 20px 0 rgba(0, 0, 0, 0.25)",
        BORDER: "1px solid rgba(245, 242, 221, 0.61)",
        CELL_BORDER: "1px solid rgba(0, 0, 0, 0.5)",
        BORDER_COLOR: "rgba(255, 255, 255, .5)",
        EXPANDABLE_ROW_BACKGROUND: "#070247",
        EXPANDABLE_ROW_BACKGROUND_2: "#A8C5EB",
        CELL_BACKGROUND_1: "rgba(31, 20, 80, 0.05)",
        CELL_BACKGROUND_2: "rgba(31, 20, 80, 0.10)",
      },
      VARIANT2: {
        BACKGROUND: "#F3F3F3",
        ROW_BACKGROUND: "#A8C5EB4D",
        BORDER_RADIUS: "10px",
        BOX_SHADOW: "0 2px 20px 0 rgba(0, 0, 0, 0.25)",
        BORDER: "1px solid rgba(245, 242, 221, 0.61)",
        CELL_BORDER: "1px solid #A5A1B9",
        BORDER_COLOR: "rgba(255, 255, 255, .5)",
        EXPANDABLE_ROW_BACKGROUND: "#070247",
        EXPANDABLE_ROW_BACKGROUND_2: "#A8C5EB",
        CELL_BACKGROUND_1: "rgba(31, 20, 80, 0.05)",
        CELL_BACKGROUND_2: "rgba(31, 20, 80, 0.10)",
      },
    },
    NOTIFICATION: {
      SUCCESS: {
        BACKGROUND: "#0EA069",
        COLOR: "#0A0D24",
      },
      WARNING: {
        BACKGROUND: "#FFCC40",
        COLOR: "#0A0D24",
      },
      ERROR: {
        BACKGROUND: "#F33E41",
        COLOR: "#0A0D24",
      },
      INFO: {
        BACKGROUND: "#009DDF",
        COLOR: "#0A0D24",
      },
    },
    POPUP: {
      BACKGROUND: "#F8981C",
      COLOR: "#0A0D24",
    },
    TAB: {
      VARIANT1: {
        ROW_BACKGROUND: "#F7F7FC",
        TITLE: "#5B6079",
        TITLE_ACTIVE: "#0A0D24",
        TITLE_BACKGROUND: "#F7F7FC",
        TITLE_ACTIVE_BACKGROUND: "#F8981C",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINE: "#D9DBE9",
        BACKGROUND_COLOR: "#F7F7FC",
        BACKGROUND_COLOR_ACTIVE: "#F7F7FC",
        BORDER_COLOR: "#E7E7E7",
        BORDER_COLOR_ACTIVE: "#CACACA",
        BORDER_WIDTH: "20px 20px 0px 20px",
        TAB_BOTTOM_BORDER: "solid 1px #D9DBE9",
        INDICATOR: "#F8981C",
      },
      //Used in ETG contained
      VARIANT2: {
        ROW_BACKGROUND: "#FAFAFA",
        TITLE: "#0A0D24",
        TITLE_ACTIVE: "#FFFFFF",
        TITLE_BACKGROUND: "#F8981C",
        TITLE_ACTIVE_BACKGROUND: "#0B0E23",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINE: "#D9DBE9",
        BACKGROUND_COLOR: "#F7F7FC",
        BACKGROUND_COLOR_ACTIVE: "#F7F7FC",
        BORDER_COLOR: "#D9DBE9",
        BORDER_COLOR_ACTIVE: "solid 1px #14142B",
        BORDER_WIDTH: "20px 20px 0px 20px",
        TAB_BOTTOM_BORDER: "solid 1px #D9DBE9",
        INDICATOR: "#F8981C",
      },
      //Used in ETG transparent contained
      VARIANT3: {
        ROW_BACKGROUND: "#FFFFFF",
        TITLE: "#5B6079",
        TITLE_ACTIVE: "#0B0E23",
        TITLE_BACKGROUND: "#FFFFFF",
        TITLE_ACTIVE_BACKGROUND: "#FFFFFF",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINE: "#D9DBE9",
        BACKGROUND_COLOR: "#F7F7FC",
        BACKGROUND_COLOR_ACTIVE: "#F7F7FC",
        BORDER_COLOR: "#D9DBE9",
        BORDER_COLOR_ACTIVE: "solid 1px #14142B",
        BORDER_WIDTH: "20px 20px 0px 20px",
        TAB_BOTTOM_BORDER: "solid 1px #D9DBE9",
        INDICATOR: "#0B0E23",
      },
    },
    GRADIENT: {
      VARIANT1: {
        BACKGROUND: "linear-gradient(90deg, #F8981C 0%, #0B0E23 100%)",
        BACKGROUND_BOTTOM: "linear-gradient(90deg, #F8981C 0%, #0B0E23 100%)",
        TITLE: "#FFFFFF",
        PARAGRAPH: "#FFFFFF",
        LABEL: "#FFFFFF",
        LINE: "#FFFFFF",
      },
      VARIANT2: {
        BACKGROUND: "linear-gradient(90deg, #B45309 0%, #F8981C 50.48%, #0B0E23 100%)",
        BACKGROUND_BOTTOM: "linear-gradient(90deg, #B45309 0%, #F8981C 50%, #0B0E23 100%)",
        TITLE: "#FFFFFF",
        PARAGRAPH: "#FFFFFF",
        LABEL: "#FFFFFF",
        LINE: "#FFFFFF",
      },
      VARIANT3: {
        BACKGROUND: "linear-gradient(90deg, #F8981C 0%, #B45309 50.48%, #0B0E23 100%)",
        BACKGROUND_BOTTOM: "linear-gradient(90deg, #F8981C 0%, #B45309 50%, #0B0E23 100%)",
        TITLE: "#FFFFFF",
        PARAGRAPH: "#FFFFFF",
        LABEL: "#FFFFFF",
        LINE: "#FFFFFF",
      },
    },
    CHIP: {
      VARIANT1: {
        BACKGROUND: "#3230BE",
        BACKGROUND_COLOR_ACTIVE: "#3230BE",
        TITLE: "#FFFFFF",
        TITLE_ACTIVE: "#FFFFFF",
        PARAGRAPH: "#FFFFFF",
        LABEL: "#FFFFFF",
        LINE: "#FFFFFF",
        BORDER: "solid 1px #3230BE",
        BORDER_RADIUS: "30px",
        PADDING: "20px",
      },
      VARIANT2: {
        BACKGROUND: "#FFFFFF",
        BACKGROUND_COLOR_ACTIVE: "#FFFFFF",
        TITLE: "#1a1a1a",
        TITLE_ACTIVE: "#1a1a1a",
        PARAGRAPH: "#1a1a1a",
        LABEL: "#1a1a1a",
        LINE: "#1a1a1a",
        BORDER: "solid 1px #FFFFFF",
        BORDER_RADIUS: "5px",
        PADDING: "20px",
      },
    },
    PROGRESSBAR: {
      VARIANT1: {
        TITLE: "#FFFFFF",
        TITLE_ACTIVE: "#FFFFFF",
        TITLE_BACKGROUND: "#E0E0E0",
        TITLE_ACTIVE_BACKGROUND: "linear-gradient(90deg, #000 0.01%, #3230BE 50.83%)",
        PARAGRAPH: "#FFFFFF",
        LABEL: "#FFFFFF",
        LINE: "#FFFFFF",
        BORDER: "solid 1px  #070247",
        BORDER_HOVER: "solid 1px  #070247",
      },
    },
    CAROUSEL: {
      VARIANT1: {
        ARROW_COLOR: "#FFFFFF",
        ARROW_COLOR_HOVER: "#FFFFFF",
        ARROW_BACKGROUND: "rgba(0, 0, 0, 0.60)",
        ARROW_BACKGROUND_HOVER: "#1a1a1a",
        ARROW_BORDER: "solid 0px  #1a1a1a",
        ARROW_BORDER_HOVER: "solid 0px  #1a1a1a",
        ARROW_RADIUS: "50%",
        DOTS_COLOR: "#D9DBE9",
        DOTS_COLOR_ACTIVE: "#070247",
      },
    },
    SKELTON: {
      BACKGROUND: "rgba(0, 0, 0, 0.11)",
      BACKGROUND_ALTERNATE: "#F2F2F7",
    },
    ANIMATION: {
      VARIANT1: {
        TRANSITION: "opacity .2s ease-out, transform .9s cubic-bezier(.19, 1, .22, 1)",
        DEFAULT_TRANSFORM: "scale(1)",
        HOVER_TRANSFORM: "scale(1.12) rotate(.02deg)",
      },
    },
    TOOLTIP: {
      VARIANT1: {
        BACKGROUND: "linear-gradient(180deg, #070247 0%, #A8C5EB 161.73%)",
        TITLE: "#FFFFFF",
        ARROW: "#070247",
      },
    },
    MODAL: {
      VARIANT1: {
        BACKGROUND: "#fff",
        BORDER_RADIUS: "20px",
      },
    },
  },
  /* Prelem Type 2 SECONDARY (Deep navy surface, white ink) - Theme Builder: Secondary #0A0D24 */
  SECONDARY_PRELEM: {
    BACKGROUND: "#0A0D24",
    TITLE: "#FFFFFF",
    TITLE_V2: "#1F1450",
    PARAGRAPH: "rgba(255,255,255,.78)",
    LABEL: "rgba(255,255,255,.6)",
    LINE: "rgba(255,255,255,.1)",
    LINK: "#F8981C",
    ACCENT_TEXT: "#F8981C",
    ANCHOR: "#FFFFFF",
    ANCHOR_HOVER: "#F8981C",
    TEXTURE:
      "repeating-linear-gradient(118deg, rgba(255,255,255,.035) 0px, rgba(255,255,255,.035) 2px, transparent 2px, transparent 62px)",
    FOCUS_RING: "#F8981C",
    BUTTON: {
      VARIANT1: {
        COLOR: "#0A0D24",
        COLOR_HOVER: "#0A0D24",
        BACKGROUND_COLOR: "#F8981C",
        BACKGROUND_COLOR_HOVER: "#FFA940",
        BORDER: "solid 2px  #F8981C",
        BORDER_HOVER: "solid 2px  #FFA940",
      },
      VARIANT2: {
        COLOR: "#FFFFFF",
        COLOR_HOVER: "#FFFFFF",
        BACKGROUND_COLOR: "rgba(255,255,255,.08)",
        BACKGROUND_COLOR_HOVER: "rgba(255,255,255,.16)",
        BORDER: "solid 2px  rgba(255,255,255,.22)",
        BORDER_HOVER: "solid 2px  rgba(255,255,255,.4)",
      },
      VARIANT3: {
        COLOR: "#F8981C",
        COLOR_HOVER: "#0A0D24",
        BACKGROUND_COLOR: "transparent",
        BACKGROUND_COLOR_HOVER: "#F8981C",
        BORDER: "solid 2px  #F8981C",
        BORDER_HOVER: "solid 2px  #F8981C",
      },
      VARIANT4: {
        COLOR: "#FFFFFF",
        COLOR_HOVER: "#F8981C",
        BACKGROUND_COLOR: "transparent",
        BACKGROUND_COLOR_HOVER: "transparent",
        BORDER: "solid 2px  transparent",
        BORDER_HOVER: "solid 2px  transparent",
      },
      VARIANT5: {
        COLOR: "#0A0D24",
        COLOR_HOVER: "#0A0D24",
        BACKGROUND_COLOR: "#F8981C",
        BACKGROUND_COLOR_HOVER: "#FFA940",
        BORDER: "solid 1px  transparent",
        BORDER_HOVER: "solid 1px  transparent",
      },
    },
    INPUT: {
      PLACEHOLDER: "#161B38",
      TEXT: "#89909A",
      TEXT_ACTIVE: "#FFFFFF",
      LABEL: "rgba(255,255,255,.6)",
      BORDER: "solid 2px transparent",
      BORDER_ACTIVE: "solid 2px #454A6B",
      BORDER_ERROR: "solid 2px #F33E41",
      BORDER_SUCCESS: "solid 2px #0FA069",
      BACKGROUND_FOCUSED: "#161B38",
      BACKGROUND_ERROR: "#FFEBEE",
      BACKGROUND_ERROR_TEXT: "#F33E41",
      BACKGROUND_SUCCESS: "#DEF5D9",
      BACKGROUND_SUCCESS_TEXT: "#0FA069",
      DISABLED: "#161B38",
    },
    SELECT: {
      PLACEHOLDER: "#161B38", //Selectbox bg
      LABEL: "#6E7191", //animated tex of focus
      TEXT: "#6E7191", //dropdownlist popup default text
      TEXT_HOVER: "#FFFFFF", //dropdownlist popup hover text color,
      TEXT_SELECTED: "#89909A",
      TEXT_BACKGROUND_HOVER: "#F8981C", //dropdownlist popup hover text background
      BORDER: "solid 2px transparent",
      BORDER_ACTIVE: "solid 2px #454A6B", //focused border color
      ICON_MARGIN: "0px 15px 0px 0px",
      POPUPOVER_OPEN: {
        PADDING: {
          sm: "14px 22px 14px 22px",
          md: "14px 22px 14px 22px",
        },
        BORDER_RADIUS: "20px",
      },
    },
    CHECKBOX: {
      BOX_COLOR: "#F8981C",
      BOX_COLOR_ACTIVE: "#F8981C",
    },
    SWITCH: {
      BOX_COLOR: "#F8981C",
      BOX_COLOR_ACTIVE: "#F8981C",
    },
    RADIO: {
      BOX_COLOR: "#F8981C",
      BOX_COLOR_ACTIVE: "#F8981C",
      SIZE: "24px",
    },
    ACCORDIAN: {
      BACKGROUND: "#161B38",
      COLOR: "#fff",
      COLOR_HEADING: "#fff",
      COLOR_PARAGRAPH: "#fff",
      BORDER_COLOR: "#454A6B",
    },
    CARDS: {
      VARIANT1: {
        BACKGROUND: "rgba(255,255,255,.06)",
        ALTERNET_BACKGROUND: "#F7F7FC",
        TITLE: "#FFFFFF",
        PARAGRAPH: "rgba(255,255,255,.78)",
        LABEL: "rgba(255,255,255,.6)",
        LINK: "#0095b5",
        BORDER_COLOR: "#454A6B",
        BORDER_COLOR_HOVER: "#454A6B",
        BOX_SHADOW: "0px 10px 15px 0px rgba(0, 0, 0, 0.03)",
        BORDER_RADIUS: "16px",
        BORDER: "1px solid #CCCCCC",
        BORDER_HOVER: "1px solid #1a1a1a",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 21.9%, #000 100%)",
      },
      VARIANT2: {
        BACKGROUND: "#161B38",
        ALTERNET_BACKGROUND: "#454A6B",
        TITLE: "#FFFFFF",
        PARAGRAPH: "#EFF0F6",
        LABEL: "rgba(255,255,255,.6)",
        BORDER_COLOR: "#D9DBE9",
        BORDER_COLOR_HOVER: "#14142B",
        BOX_SHADOW: "0px 10px 15px 0px rgba(0, 0, 0, 0.03)",
        BORDER_RADIUS: "20px",
        BORDER: "1px solid #CCCCCC",
        BORDER_HOVER: "1px solid #1a1a1a",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 21.9%, #000 100%)",
      },
      VARIANT3: {
        //used this for home page hero matches card
        BACKGROUND: "#F2F2F7",
        ALTERNET_BACKGROUND: "#E2E2EA",
        TITLE: "#020403",
        PARAGRAPH: "#4E4B66",
        LABEL: "#5B6079",
        LINK: "#1F234C",
        BORDER_COLOR: "rgba(0, 15, 225, 1)",
        BORDER_COLOR_HOVER: "linear-gradient(90deg, #a9aff6 0%, #E2E2EA 40%, #E2E2EA 100%)",
        BOX_SHADOW: "0px 10px 15px 0px rgba(0, 0, 0, 0.03)",
        BORDER_RADIUS: "20px",
        BORDER: "1px solid rgba(0, 0, 0, 0.30)",
        BORDER_HOVER: "1px solid rgba(0, 0, 0, 0.30)",
        BACKGROUND_GRADIENT: "linear-gradient(90deg, #a9aff6 0%, #E2E2EA 40%, #E2E2EA 100%)",
      },
      ECOM_CARD_BACKGROUND: "#fdfdfd", //not to be changed
      // Brand/emphasis card variant (KIWI-6221 ServiceCardFeatureGrid)
      BRAND_GRADIENT: "linear-gradient(140deg, #1F234C 0%, #003D79 100%)",
      CARD_ACCENT: "#F8981C",
      BRAND_CARD_ACCENT: "#F59E0B",
      BRAND_ICON_CHIP: "255, 255, 255, 0.14",
      CARD_ICON_CHIP: "#1F234C",
      CARD_BOX_SHADOW: "0 2px 12px rgba(10, 13, 36, 0.07)",
      CARD_BOX_SHADOW_HOVER: "0 18px 40px rgba(10, 13, 36, 0.15)",
      ECOM_MASK_BACKGROUND: "#14142B", //not to be changed
    },
    ACCENTS: {
      VARIANT1: {
        BACKGROUND: "#161B38",
        TITLE: "#FFFFFF",
        PARAGRAPH: "#EFF0F6",
        LABEL: "#F8981C",
        LINE: "#454A6B",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, #A8C5EB -57.3%, #FFF 100%)",
      },
      VARIANT2: {
        BACKGROUND: "#1E2340",
        TITLE: "#FFFFFF",
        PARAGRAPH: "#EFF0F6",
        LABEL: "#F8981C",
        LINE: "#454A6B",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, #A8C5EB -57.3%, #FFF 100%)",
      },
      VARIANT3: {
        BACKGROUND: "#454A6B",
        TITLE: "#FFFFFF",
        PARAGRAPH: "#EFF0F6",
        LABEL: "#FFFFFF",
        LINE: "#6E7191",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, #A8C5EB -57.3%, #FFF 100%)",
      },
      VARIANT4: {
        BACKGROUND: "#B45309",
        TITLE: "#FFFFFF",
        PARAGRAPH: "#FFFFFF",
        LABEL: "#FFFFFF",
        LINE: "#6E7191",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT:
          "linear-gradient(180deg, var(--Accent-ETG-Sky, #A8C5EB) -57.3%, #FFF 100%)",
      },
      VARIANT5: {
        BACKGROUND: "#6E7191",
        TITLE: "#FFFFFF",
        PARAGRAPH: "#FFFFFF",
        LABEL: "#FFFFFF",
        LINE: "#6E7191",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, #A8C5EB -57.3%, #FFF 100%)",
      },
      VARIANT6: {
        BACKGROUND: "#F8981C",
        TITLE: "#0A0D24",
        PARAGRAPH: "#0A0D24",
        LABEL: "#0A0D24",
        LINE: "#FFFFFF",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, #A8C5EB -57.3%, #FFF 100%)",
      },
      VARIANT7: {
        BACKGROUND: "linear-gradient(180deg, #FAFAFA 0%, #F8F8F8 106.2%)",
        TITLE: "#B4881B",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINE: "#BB9C2B",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, #A8C5EB -57.3%, #FFF 100%)",
      },
    },
    TABLE: {
      VARIANT1: {
        BACKGROUND: "rgba(255, 255, 255, 1)",
        ROW_BACKGROUND: "rgba(168, 197, 235, 0.25)",
        BORDER_RADIUS: "10px",
        BOX_SHADOW: "0 2px 20px 0 rgba(0, 0, 0, 0.25)",
        BORDER: "1px solid rgba(245, 242, 221, 0.61)",
        CELL_BORDER: "1px solid rgba(0, 0, 0, 0.5)",
        BORDER_COLOR: "rgba(255, 255, 255, .5)",
        EXPANDABLE_ROW_BACKGROUND: "#070247",
        EXPANDABLE_ROW_BACKGROUND_2: "#A8C5EB",
        CELL_BACKGROUND_1: "rgba(31, 20, 80, 0.05)",
        CELL_BACKGROUND_2: "rgba(31, 20, 80, 0.10)",
      },
      VARIANT2: {
        BACKGROUND: "#F3F3F3",
        ROW_BACKGROUND: "#A8C5EB4D",
        BORDER_RADIUS: "10px",
        BOX_SHADOW: "0 2px 20px 0 rgba(0, 0, 0, 0.25)",
        BORDER: "1px solid rgba(245, 242, 221, 0.61)",
        CELL_BORDER: "1px solid #A5A1B9",
        BORDER_COLOR: "rgba(255, 255, 255, .5)",
        EXPANDABLE_ROW_BACKGROUND: "#070247",
        EXPANDABLE_ROW_BACKGROUND_2: "#A8C5EB",
        CELL_BACKGROUND_1: "rgba(31, 20, 80, 0.05)",
        CELL_BACKGROUND_2: "rgba(31, 20, 80, 0.10)",
      },
    },
    NOTIFICATION: {
      SUCCESS: {
        BACKGROUND: "#0EA069",
        COLOR: "#0A0D24",
      },
      WARNING: {
        BACKGROUND: "#FFCC40",
        COLOR: "#0A0D24",
      },
      ERROR: {
        BACKGROUND: "#F33E41",
        COLOR: "#0A0D24",
      },
      INFO: {
        BACKGROUND: "#009DDF",
        COLOR: "#0A0D24",
      },
    },
    POPUP: {
      BACKGROUND: "#F8981C",
      COLOR: "#0A0D24",
    },
    TAB: {
      VARIANT1: {
        ROW_BACKGROUND: "#161B38",
        TITLE: "#C7C9D6",
        TITLE_ACTIVE: "#0A0D24",
        TITLE_BACKGROUND: "#161B38",
        TITLE_ACTIVE_BACKGROUND: "#F8981C",
        PARAGRAPH: "#EFF0F6",
        LABEL: "#F8981C",
        LINE: "#454A6B",
        BACKGROUND_COLOR: "transparent",
        BACKGROUND_COLOR_ACTIVE: "transparent",
        BORDER_COLOR: "#D9DBE9",
        BORDER_COLOR_ACTIVE: "#F8981C",
        BORDER_WIDTH: "20px 20px 0px 20px",
        TAB_BOTTOM_BORDER: "solid 1px #454A6B",
        INDICATOR: "#F8981C",
        BORDER_RADIUS: "40px",
        PADDING: "12px 14px",
        INDICATOR_HEIGHT: "0px",
      },
      //Used in ETG contained
      VARIANT2: {
        ROW_BACKGROUND: "#161B38",
        TITLE: "#0A0D24",
        TITLE_ACTIVE: "#FFFFFF",
        TITLE_BACKGROUND: "#F8981C",
        TITLE_ACTIVE_BACKGROUND: "#0B0E23",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINE: "#D9DBE9",
        BACKGROUND_COLOR: "#F7F7FC",
        BACKGROUND_COLOR_ACTIVE: "#F7F7FC",
        BORDER_COLOR: "#D9DBE9",
        BORDER_COLOR_ACTIVE: "solid 1px #14142B",
        BORDER_WIDTH: "20px 20px 0px 20px",
        TAB_BOTTOM_BORDER: "solid 1px #D9DBE9",
        INDICATOR: "#F8981C",
        BORDER_RADIUS: "40px",
        PADDING: "12px 14px",
        INDICATOR_HEIGHT: "0px",
      },
      //Used in ETG transparent contained
      VARIANT3: {
        ROW_BACKGROUND: "#0B0E23",
        TITLE: "#C7C9D6",
        TITLE_ACTIVE: "#FFFFFF",
        TITLE_BACKGROUND: "#0B0E23",
        TITLE_ACTIVE_BACKGROUND: "#0B0E23",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINE: "#D9DBE9",
        BACKGROUND_COLOR: "#F7F7FC",
        BACKGROUND_COLOR_ACTIVE: "#F7F7FC",
        BORDER_COLOR: "#D9DBE9",
        BORDER_COLOR_ACTIVE: "solid 1px #14142B",
        BORDER_WIDTH: "20px 20px 0px 20px",
        TAB_BOTTOM_BORDER: "solid 1px #454A6B",
        INDICATOR: "#FFFFFF",
        BORDER_RADIUS: "40px",
        PADDING: "12px 14px",
        INDICATOR_HEIGHT: "0px",
      },
    },
    GRADIENT: {
      VARIANT1: {
        BACKGROUND: "linear-gradient(90deg, #F8981C 0%, #0B0E23 100%)",
        BACKGROUND_BOTTOM: "linear-gradient(90deg, #F8981C 0%, #0B0E23 100%)",
        TITLE: "#FFFFFF",
        PARAGRAPH: "#FFFFFF",
        LABEL: "#FFFFFF",
        LINE: "#FFFFFF",
      },
      VARIANT2: {
        BACKGROUND: "linear-gradient(90deg, #B45309 0%, #F8981C 50.48%, #0B0E23 100%)",
        BACKGROUND_BOTTOM: "linear-gradient(90deg, #B45309 0%, #F8981C 50%, #0B0E23 100%)",
        TITLE: "#FFFFFF",
        PARAGRAPH: "#FFFFFF",
        LABEL: "#FFFFFF",
        LINE: "#FFFFFF",
      },
      VARIANT3: {
        BACKGROUND: "linear-gradient(90deg, #F8981C 0%, #B45309 50.48%, #0B0E23 100%)",
        BACKGROUND_BOTTOM: "linear-gradient(90deg, #F8981C 0%, #B45309 50%, #0B0E23 100%)",
        TITLE: "#FFFFFF",
        PARAGRAPH: "#FFFFFF",
        LABEL: "#FFFFFF",
        LINE: "#FFFFFF",
      },
    },
    CHIP: {
      VARIANT1: {
        BACKGROUND: "#3230BE",
        BACKGROUND_COLOR_ACTIVE: "#3230BE",
        TITLE: "#FFFFFF",
        TITLE_ACTIVE: "#FFFFFF",
        PARAGRAPH: "#FFFFFF",
        LABEL: "#FFFFFF",
        LINE: "#FFFFFF",
        BORDER: "solid 1px #3230BE",
        BORDER_RADIUS: "30px",
        PADDING: "20px",
      },
      VARIANT2: {
        BACKGROUND: "#FFFFFF",
        BACKGROUND_COLOR_ACTIVE: "#FFFFFF",
        TITLE: "#1a1a1a",
        TITLE_ACTIVE: "#1a1a1a",
        PARAGRAPH: "#1a1a1a",
        LABEL: "#1a1a1a",
        LINE: "#1a1a1a",
        BORDER: "solid 1px #FFFFFF",
        BORDER_RADIUS: "5px",
        PADDING: "20px",
      },
    },
    PROGRESSBAR: {
      VARIANT1: {
        TITLE: "#FFFFFF",
        TITLE_ACTIVE: "#FFFFFF",
        TITLE_BACKGROUND: "#E0E0E0",
        TITLE_ACTIVE_BACKGROUND: "linear-gradient(90deg, #000 0.01%, #3230BE 50.83%)",
        PARAGRAPH: "#FFFFFF",
        LABEL: "#FFFFFF",
        LINE: "#FFFFFF",
        BORDER: "solid 1px  #070247",
        BORDER_HOVER: "solid 1px  #070247",
      },
    },
    CAROUSEL: {
      VARIANT1: {
        ARROW_COLOR: "#FFFFFF",
        ARROW_COLOR_HOVER: "#FFFFFF",
        ARROW_BACKGROUND: "rgba(0, 0, 0, 0.60)",
        ARROW_BACKGROUND_HOVER: "#1a1a1a",
        ARROW_BORDER: "solid 0px  #1a1a1a",
        ARROW_BORDER_HOVER: "solid 0px  #1a1a1a",
        ARROW_RADIUS: "50%",
        DOTS_COLOR: "#D9DBE9",
        DOTS_COLOR_ACTIVE: "#070247",
      },
    },
    SKELTON: {
      BACKGROUND: "rgba(0, 0, 0, 0.11)",
      BACKGROUND_ALTERNATE: "#F2F2F7",
    },
    ANIMATION: {
      VARIANT1: {
        TRANSITION: "opacity .2s ease-out, transform .9s cubic-bezier(.19, 1, .22, 1)",
        DEFAULT_TRANSFORM: "scale(1)",
        HOVER_TRANSFORM: "scale(1.12) rotate(.02deg)",
      },
    },
    TOOLTIP: {
      VARIANT1: {
        BACKGROUND: "linear-gradient(180deg, #070247 0%, #A8C5EB 161.73%)",
        TITLE: "#FFFFFF",
        ARROW: "#070247",
      },
    },
    MODAL: {
      VARIANT1: {
        BACKGROUND: "#fff",
        BORDER_RADIUS: "20px",
      },
    },
  },
  /* Prelem Type 3 TERTIARY (Soft grey-blue surface, navy ink) - Theme Builder: Tertiary #F5F6FB */
  TERTIARY_PRELEM: {
    BACKGROUND: "#F5F6FB",
    TITLE: "#12152E",
    TITLE_V2: "#1F1450",
    PARAGRAPH: "#5B6079",
    LABEL: "#5B6079",
    LINE: "#DFE1EC",
    LINK: "#A85A00",
    ACCENT_TEXT: "#A85A00",
    ANCHOR: "#1F234C",
    ANCHOR_HOVER: "#A85A00",
    TEXTURE:
      "repeating-linear-gradient(118deg, rgba(10,13,36,.03) 0px, rgba(10,13,36,.03) 2px, transparent 2px, transparent 62px)",
    FOCUS_RING: "#1F234C",
    BUTTON: {
      /* Dark ink on amber, not white: #FFFFFF on #F8981C is ~2.2:1 and fails WCAG AA for
         button text, while #0B0E23 on #F8981C is ~8:1. Hover lightens the amber instead of
         inverting to white, which had the same contrast problem in reverse. */
      VARIANT1: {
        COLOR: "#0A0D24",
        COLOR_HOVER: "#0A0D24",
        BACKGROUND_COLOR: "#F8981C",
        BACKGROUND_COLOR_HOVER: "#FFA940",
        BORDER: "solid 2px  #F8981C",
        BORDER_HOVER: "solid 2px  #FFA940",
      },
      VARIANT2: {
        COLOR: "#1F234C",
        COLOR_HOVER: "#FFFFFF",
        BACKGROUND_COLOR: "transparent",
        BACKGROUND_COLOR_HOVER: "#1F234C",
        BORDER: "solid 2px  #1F234C",
        BORDER_HOVER: "solid 2px  #1F234C",
      },
      VARIANT3: {
        COLOR: "#A85A00",
        COLOR_HOVER: "#0A0D24",
        BACKGROUND_COLOR: "transparent",
        BACKGROUND_COLOR_HOVER: "#F8981C",
        BORDER: "solid 2px  #A85A00",
        BORDER_HOVER: "solid 2px  #F8981C",
      },
      VARIANT4: {
        COLOR: "#3C3C3C",
        COLOR_HOVER: "#A85A00",
        BACKGROUND_COLOR: "transparent",
        BACKGROUND_COLOR_HOVER: "transparent",
        BORDER: "solid 2px  transparent",
        BORDER_HOVER: "solid 2px  transparent",
      },
      VARIANT5: {
        COLOR: "#FFFFFF",
        COLOR_HOVER: "#0A0D24",
        BACKGROUND_COLOR: "#0B0E23",
        BACKGROUND_COLOR_HOVER: "#F8981C",
        BORDER: "solid 1px  transparent",
        BORDER_HOVER: "solid 1px  transparent",
      },
    },
    INPUT: {
      PLACEHOLDER: "#EFF0F6",
      TEXT: "#14142B",
      TEXT_ACTIVE: "#14142B",
      LABEL: "#5B6079",
      BORDER: "solid 2px transparent",
      BORDER_ACTIVE: "solid 2px #14142B",
      BORDER_ERROR: "solid 2px #F33E41",
      BORDER_SUCCESS: "solid 2px #0FA069",
      BACKGROUND_FOCUSED: "#fff",
      BACKGROUND_ERROR: "#FFEBEE",
      BACKGROUND_ERROR_TEXT: "#F33E41",
      BACKGROUND_SUCCESS: "#DEF5D9",
      BACKGROUND_SUCCESS_TEXT: "#0FA069",
      DISABLED: "#EFF0F6",
    },
    SELECT: {
      PLACEHOLDER: "#EFF0F6", //Selectbox bg
      LABEL: "#6E7191", //animated tex of focus
      TEXT: "#6E7191", //dropdownlist popup default text
      TEXT_HOVER: "#14142B", //dropdownlist popup hover text color
      TEXT_SELECTED: "#14142B", //dropdownlist selected text color
      TEXT_BACKGROUND_HOVER: "#FCFCFC", //dropdownlist popup hover text background
      BORDER: "solid 2px transparent",
      BORDER_ACTIVE: "solid 2px #14142B", //focused border color
      ICON_MARGIN: "0px 15px 0px 0px",
      POPUPOVER_OPEN: {
        PADDING: {
          sm: "14px 22px 14px 22px",
          md: "14px 22px 14px 22px",
        },
        BORDER_RADIUS: "20px",
      },
    },
    CHECKBOX: {
      BOX_COLOR: "#14142B",
      BOX_COLOR_ACTIVE: "#F8981C",
    },
    SWITCH: {
      BOX_COLOR: "#6E7191",
      BOX_COLOR_ACTIVE: "#F8981C",
    },
    RADIO: {
      BOX_COLOR: "#14142B",
      BOX_COLOR_ACTIVE: "#F8981C",
      SIZE: "24px",
    },
    ACCORDIAN: {
      BACKGROUND: "#fff",
      COLOR: "#14142B",
      COLOR_HEADING: "#14142B",
      COLOR_PARAGRAPH: "#14142B",
      BORDER_COLOR: "#D9DBE9",
    },
    CARDS: {
      VARIANT1: {
        BACKGROUND: "#FFFFFF",
        ALTERNET_BACKGROUND: "#F7F7FC",
        TITLE: "#12152E",
        PARAGRAPH: "#5B6079",
        LABEL: "#5B6079",
        LINK: "#1F234C",
        BORDER_COLOR: "#D9DBE9",
        BORDER_COLOR_HOVER: "#14142B",
        BOX_SHADOW: "0px 10px 15px 0px rgba(0, 0, 0, 0.03)",
        BORDER_RADIUS: "16px",
        BORDER: "1px solid #CCCCCC",
        BORDER_HOVER: "1px solid #1a1a1a",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 21.9%, #000 100%)",
      },
      VARIANT2: {
        BACKGROUND: "#FEF3E2",
        ALTERNET_BACKGROUND: "#F8981C",
        TITLE: "#A85A00",
        PARAGRAPH: "#4E4B66",
        LABEL: "#5B6079",
        LINK: "#1F234C",
        BORDER_COLOR: "#C0C0C0",
        BORDER_COLOR_HOVER: "#14142B",
        BOX_SHADOW: "0px 10px 15px 0px rgba(0, 0, 0, 0.03)",
        BORDER_RADIUS: "20px",
        BORDER: "1px solid #CCCCCC",
        BORDER_HOVER: "1px solid #1a1a1a",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 21.9%, #000 100%)",
      },
      VARIANT3: {
        //used this for home page hero matches card
        BACKGROUND: "#F2F2F7",
        ALTERNET_BACKGROUND: "#E2E2EA",
        TITLE: "#020403",
        PARAGRAPH: "#4E4B66",
        LABEL: "#5B6079",
        LINK: "#1F234C",
        BORDER_COLOR: "rgba(0, 15, 225, 1)",
        BORDER_COLOR_HOVER: "linear-gradient(90deg, #a9aff6 0%, #E2E2EA 40%, #E2E2EA 100%)",
        BOX_SHADOW: "0px 10px 15px 0px rgba(0, 0, 0, 0.03)",
        BORDER_RADIUS: "20px",
        BORDER: "1px solid rgba(0, 0, 0, 0.30)",
        BORDER_HOVER: "1px solid rgba(0, 0, 0, 0.30)",
        BACKGROUND_GRADIENT: "linear-gradient(90deg, #a9aff6 0%, #E2E2EA 40%, #E2E2EA 100%)",
      },
      ECOM_CARD_BACKGROUND: "#fdfdfd",
      // Brand/emphasis card variant (KIWI-6221 ServiceCardFeatureGrid)
      BRAND_GRADIENT: "linear-gradient(140deg, #1F234C 0%, #003D79 100%)",
      CARD_ACCENT: "#B45309",
      BRAND_CARD_ACCENT: "#F59E0B",
      BRAND_ICON_CHIP: "255, 255, 255, 0.14",
      CARD_ICON_CHIP: "#1F234C",
      CARD_BOX_SHADOW: "0 2px 12px rgba(10, 13, 36, 0.07)",
      CARD_BOX_SHADOW_HOVER: "0 18px 40px rgba(10, 13, 36, 0.15)",
      ECOM_MASK_BACKGROUND: "#14142B",
    },
    ACCENTS: {
      VARIANT1: {
        BACKGROUND: "#F6F6F6",
        TITLE: "#14142B",
        PARAGRAPH: "#4E4B66",
        LABEL: "#5B6079",
        LINE: "#D9DBE9",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, #A8C5EB -57.3%, #FFF 100%)",
      },
      VARIANT2: {
        BACKGROUND: "#f2f2f2",
        TITLE: "#14142B",
        PARAGRAPH: "#4E4B66",
        LABEL: "#5B6079",
        LINE: "#D9DBE9",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, #A8C5EB -57.3%, #FFF 100%)",
      },
      VARIANT3: {
        BACKGROUND: "#FCE7C0",
        TITLE: "#14142B",
        PARAGRAPH: "#4E4B66",
        LABEL: "#5B6079",
        LINE: "#D9DBE9",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, #A8C5EB -57.3%, #FFF 100%)",
      },
      VARIANT4: {
        BACKGROUND: "#F9D9A0",
        TITLE: "#14142B",
        PARAGRAPH: "#4E4B66",
        LABEL: "#5B6079",
        LINE: "#D9DBE9",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, #A8C5EB -57.3%, #FFF 100%)",
      },
      VARIANT5: {
        BACKGROUND: "#F5C778",
        TITLE: "#14142B",
        PARAGRAPH: "#4E4B66",
        LABEL: "#4E4B66",
        LINE: "#D9DBE9",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, #A8C5EB -57.3%, #FFF 100%)",
      },
      VARIANT6: {
        BACKGROUND: "#F8981C",
        TITLE: "#0A0D24",
        PARAGRAPH: "#0A0D24",
        LABEL: "#0A0D24",
        LINE: "#FFFFFF",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, #A8C5EB -57.3%, #FFF 100%)",
      },
      VARIANT7: {
        BACKGROUND: "linear-gradient(180deg, #FAFAFA 0%, #F8F8F8 106.2%)",
        TITLE: "#B4881B",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINE: "#BB9C2B",
        ICON: "#4C4A7D",
        BOX_SHADOW: "0 15px 20px 0 rgba(0, 0, 0, 0.04)",
        BACKGROUND_GRADIENT: "linear-gradient(180deg, #A8C5EB -57.3%, #FFF 100%)",
      },
    },
    TABLE: {
      VARIANT1: {
        BACKGROUND: "rgba(255, 255, 255, 1)",
        ROW_BACKGROUND: "rgba(168, 197, 235, 0.25)",
        BORDER_RADIUS: "10px",
        BOX_SHADOW: "0 2px 20px 0 rgba(0, 0, 0, 0.25)",
        BORDER: "1px solid rgba(245, 242, 221, 0.61)",
        CELL_BORDER: "1px solid rgba(0, 0, 0, 0.5)",
        BORDER_COLOR: "rgba(255, 255, 255, .5)",
        EXPANDABLE_ROW_BACKGROUND: "#070247",
        EXPANDABLE_ROW_BACKGROUND_2: "#A8C5EB",
        CELL_BACKGROUND_1: "rgba(31, 20, 80, 0.05)",
        CELL_BACKGROUND_2: "rgba(31, 20, 80, 0.10)",
      },
      VARIANT2: {
        BACKGROUND: "#F3F3F3",
        ROW_BACKGROUND: "#A8C5EB4D",
        BORDER_RADIUS: "10px",
        BOX_SHADOW: "0 2px 20px 0 rgba(0, 0, 0, 0.25)",
        BORDER: "1px solid rgba(245, 242, 221, 0.61)",
        CELL_BORDER: "1px solid #A5A1B9",
        BORDER_COLOR: "rgba(255, 255, 255, .5)",
        EXPANDABLE_ROW_BACKGROUND: "#070247",
        EXPANDABLE_ROW_BACKGROUND_2: "#A8C5EB",
        CELL_BACKGROUND_1: "rgba(31, 20, 80, 0.05)",
        CELL_BACKGROUND_2: "rgba(31, 20, 80, 0.10)",
      },
    },
    NOTIFICATION: {
      SUCCESS: {
        BACKGROUND: "#0EA069",
        COLOR: "#0A0D24",
      },
      WARNING: {
        BACKGROUND: "#FFCC40",
        COLOR: "#0A0D24",
      },
      ERROR: {
        BACKGROUND: "#F33E41",
        COLOR: "#0A0D24",
      },
      INFO: {
        BACKGROUND: "#009DDF",
        COLOR: "#0A0D24",
      },
    },
    POPUP: {
      BACKGROUND: "#F8981C",
      COLOR: "#0A0D24",
    },
    TAB: {
      VARIANT1: {
        ROW_BACKGROUND: "#F7F7FC",
        TITLE: "#5B6079",
        TITLE_ACTIVE: "#0A0D24",
        TITLE_BACKGROUND: "#F7F7FC",
        TITLE_ACTIVE_BACKGROUND: "#F8981C",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINE: "#D9DBE9",
        BACKGROUND_COLOR: "#F7F7FC",
        BACKGROUND_COLOR_ACTIVE: "#F7F7FC",
        BORDER_COLOR: "#E7E7E7",
        BORDER_COLOR_ACTIVE: "#CACACA",
        BORDER_WIDTH: "20px 20px 0px 20px",
        TAB_BOTTOM_BORDER: "solid 1px #D9DBE9",
        INDICATOR: "#F8981C",
      },
      //Used in ETG contained
      VARIANT2: {
        ROW_BACKGROUND: "#FAFAFA",
        TITLE: "#0A0D24",
        TITLE_ACTIVE: "#FFFFFF",
        TITLE_BACKGROUND: "#F8981C",
        TITLE_ACTIVE_BACKGROUND: "#0B0E23",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINE: "#D9DBE9",
        BACKGROUND_COLOR: "#F7F7FC",
        BACKGROUND_COLOR_ACTIVE: "#F7F7FC",
        BORDER_COLOR: "#D9DBE9",
        BORDER_COLOR_ACTIVE: "solid 1px #14142B",
        BORDER_WIDTH: "20px 20px 0px 20px",
        TAB_BOTTOM_BORDER: "solid 1px #D9DBE9",
        INDICATOR: "#F8981C",
      },
      //Used in ETG transparent contained
      VARIANT3: {
        ROW_BACKGROUND: "#FFFFFF",
        TITLE: "#5B6079",
        TITLE_ACTIVE: "#0B0E23",
        TITLE_BACKGROUND: "#FFFFFF",
        TITLE_ACTIVE_BACKGROUND: "#FFFFFF",
        PARAGRAPH: "#4E4B66",
        LABEL: "#6E7191",
        LINE: "#D9DBE9",
        BACKGROUND_COLOR: "#F7F7FC",
        BACKGROUND_COLOR_ACTIVE: "#F7F7FC",
        BORDER_COLOR: "#D9DBE9",
        BORDER_COLOR_ACTIVE: "solid 1px #14142B",
        BORDER_WIDTH: "20px 20px 0px 20px",
        TAB_BOTTOM_BORDER: "solid 1px #D9DBE9",
        INDICATOR: "#0B0E23",
      },
    },
    GRADIENT: {
      VARIANT1: {
        BACKGROUND: "linear-gradient(90deg, #F8981C 0%, #0B0E23 100%)",
        BACKGROUND_BOTTOM: "linear-gradient(90deg, #F8981C 0%, #0B0E23 100%)",
        TITLE: "#FFFFFF",
        PARAGRAPH: "#FFFFFF",
        LABEL: "#FFFFFF",
        LINE: "#FFFFFF",
      },
      VARIANT2: {
        BACKGROUND: "linear-gradient(90deg, #B45309 0%, #F8981C 50.48%, #0B0E23 100%)",
        BACKGROUND_BOTTOM: "linear-gradient(90deg, #B45309 0%, #F8981C 50%, #0B0E23 100%)",
        TITLE: "#FFFFFF",
        PARAGRAPH: "#FFFFFF",
        LABEL: "#FFFFFF",
        LINE: "#FFFFFF",
      },
      VARIANT3: {
        BACKGROUND: "linear-gradient(90deg, #F8981C 0%, #B45309 50.48%, #0B0E23 100%)",
        BACKGROUND_BOTTOM: "linear-gradient(90deg, #F8981C 0%, #B45309 50%, #0B0E23 100%)",
        TITLE: "#FFFFFF",
        PARAGRAPH: "#FFFFFF",
        LABEL: "#FFFFFF",
        LINE: "#FFFFFF",
      },
    },
    CHIP: {
      VARIANT1: {
        BACKGROUND: "#3230BE",
        BACKGROUND_COLOR_ACTIVE: "#3230BE",
        TITLE: "#FFFFFF",
        TITLE_ACTIVE: "#FFFFFF",
        PARAGRAPH: "#FFFFFF",
        LABEL: "#FFFFFF",
        LINE: "#FFFFFF",
        BORDER: "solid 1px #3230BE",
        BORDER_RADIUS: "30px",
        PADDING: "20px",
      },
      VARIANT2: {
        BACKGROUND: "#FFFFFF",
        BACKGROUND_COLOR_ACTIVE: "#FFFFFF",
        TITLE: "#1a1a1a",
        TITLE_ACTIVE: "#1a1a1a",
        PARAGRAPH: "#1a1a1a",
        LABEL: "#1a1a1a",
        LINE: "#1a1a1a",
        BORDER: "solid 1px #FFFFFF",
        BORDER_RADIUS: "5px",
        PADDING: "20px",
      },
    },
    PROGRESSBAR: {
      VARIANT1: {
        TITLE: "#FFFFFF",
        TITLE_ACTIVE: "#FFFFFF",
        TITLE_BACKGROUND: "#E0E0E0",
        TITLE_ACTIVE_BACKGROUND: "linear-gradient(90deg, #000 0.01%, #3230BE 50.83%)",
        PARAGRAPH: "#FFFFFF",
        LABEL: "#FFFFFF",
        LINE: "#FFFFFF",
        BORDER: "solid 1px  #070247",
        BORDER_HOVER: "solid 1px  #070247",
      },
    },
    CAROUSEL: {
      VARIANT1: {
        ARROW_COLOR: "#FFFFFF",
        ARROW_COLOR_HOVER: "#FFFFFF",
        ARROW_BACKGROUND: "rgba(0, 0, 0, 0.60)",
        ARROW_BACKGROUND_HOVER: "#1a1a1a",
        ARROW_BORDER: "solid 0px  #1a1a1a",
        ARROW_BORDER_HOVER: "solid 0px  #1a1a1a",
        ARROW_RADIUS: "50%",
        DOTS_COLOR: "#D9DBE9",
        DOTS_COLOR_ACTIVE: "#070247",
      },
    },
    SKELTON: {
      BACKGROUND: "rgba(0, 0, 0, 0.11)",
      BACKGROUND_ALTERNATE: "#F2F2F7",
    },
    ANIMATION: {
      VARIANT1: {
        TRANSITION: "opacity .2s ease-out, transform .9s cubic-bezier(.19, 1, .22, 1)",
        DEFAULT_TRANSFORM: "scale(1)",
        HOVER_TRANSFORM: "scale(1.12) rotate(.02deg)",
      },
    },
    TOOLTIP: {
      VARIANT1: {
        BACKGROUND: "linear-gradient(180deg, #070247 0%, #A8C5EB 161.73%)",
        TITLE: "#FFFFFF",
        ARROW: "#070247",
      },
    },
    MODAL: {
      VARIANT1: {
        BACKGROUND: "#fff",
        BORDER_RADIUS: "20px",
      },
    },
  },
  HEADER: {
    HEADER_HEIGHT: "60px",
    VARIANT1: {
      BACKGROUND: "#0B0E23",
      BACKGROUND_HOVER: "#0B0E23",
      TITLE: "#FFFFFF",
      TITLE_HOVER: "#FFFFFF",
      PARAGRAPH: "#FFFFFF",
      PARAGRAPH_HOVER: "#FFFFFF",
      LABEL: "#F8981C",
      LABEL_HOVER: "#F8981C",
      LINE: "#0B0E23",
      LINE_HOVER: "#D9DBE9",
      BORDER_COLOR: "#454A6B",
      BORDER_COLOR_HOVER: "#14142B",
      LINK: "#F8981C",
      LINK_HOVER: "#F8981C",
      BUTTON: {
        COLOR: "#fff",
        COLOR_HOVER: "#fff",
        BACKGROUND_COLOR: "transparent",
        BACKGROUND_COLOR_HOVER: "transparent",
        BORDER_COLOR: "#FFFFFF",
        BORDER_COLOR_HOVER: "#F8981C",
      },
      BADGE: {
        BACKGROUND: "#F8981C",
        TITLE: "#FFF",
      },
      SUBMENU: {
        CARD_BACKGROUND: "#FFF",
        BACKGROUND: "#FFF",
        BACKGROUND_HOVER: "#FFF",
        TITLE: "#0B0E23",
        TITLE_HOVER: "#F8981C",
        PARAGRAPH: "#3A3A3A",
        PARAGRAPH_HOVER: "#3A3A3A",
        LABEL: "#F8981C",
        LABEL_HOVER: "#F8981C",
        LINE: "#D9DBE9",
        LINE_HOVER: "#D9DBE9",
        BORDER_COLOR: "#D9DBE9",
        BORDER_COLOR_HOVER: "#14142B",
        LINK: "#F8981C",
        LINK_HOVER: "#F8981C",
      },
      TOPMENU: {
        BACKGROUND: "#F8981C",
        BACKGROUND_HOVER: "#C9820A",
        TITLE: "#FFFFFF",
        TITLE_HOVER: "#FFFFFF",
        PARAGRAPH: "#FFFFFF",
        PARAGRAPH_HOVER: "#FFFFFF",
        LINE: "#D9DBE9",
        LINE_HOVER: "#D9DBE9",
        BUTTON: {
          COLOR: "#fff",
          COLOR_HOVER: "#fff",
          BACKGROUND_COLOR: "transparent",
          BACKGROUND_COLOR_HOVER: "transparent",
          BORDER_COLOR: "#FFFFFF",
          BORDER_COLOR_HOVER: "#F8981C",
        },
      },
    },
    VARIANT2: {
      BACKGROUND: "#0B0E23",
      BACKGROUND_HOVER: "#161B38",
      TITLE: "#FFFFFF",
      TITLE_HOVER: "#F8981C",
      PARAGRAPH: "#FFFFFF",
      PARAGRAPH_HOVER: "#FFFFFF",
      LABEL: "#6E7191",
      LABEL_HOVER: "#6E7191",
      LINE: "#454A6B",
      LINE_HOVER: "#D9DBE9",
      BORDER_COLOR: "#D9DBE9",
      BORDER_COLOR_HOVER: "#14142B",
      LINK: "#F8981C",
      LINK_HOVER: "#F8981C",
      BUTTON: {
        COLOR: "#fff",
        COLOR_HOVER: "#F8981C",
        BACKGROUND_COLOR: "transparent",
        BACKGROUND_COLOR_HOVER: "transparent",
        BORDER_COLOR: "#FFFFFF",
        BORDER_COLOR_HOVER: "#F8981C",
      },
      BADGE: {
        BACKGROUND: "#F8981C",
        TITLE: "#FFFFFF",
      },
      SUBMENU: {
        CARD_BACKGROUND: "#FFF",
        BACKGROUND: "#FFF",
        BACKGROUND_HOVER: "#161B38",
        TITLE: "#0B0E23",
        TITLE_HOVER: "#FFF",
        PARAGRAPH: "#3A3A3A",
        PARAGRAPH_HOVER: "#FFF",
        LABEL: "#F8981C",
        LABEL_HOVER: "#F8981C",
        LINE: "#D9DBE9",
        LINE_HOVER: "#D9DBE9",
        BORDER_COLOR: "#D9DBE9",
        BORDER_COLOR_HOVER: "#14142B",
        LINK: "#F8981C",
        LINK_HOVER: "#F8981C",
      },
      TOPMENU: {
        BACKGROUND: "#F8981C",
        BACKGROUND_HOVER: "#C9820A",
        TITLE: "#FFFFFF",
        TITLE_HOVER: "#FFFFFF",
        PARAGRAPH: "#FFFFFF",
        PARAGRAPH_HOVER: "#FFFFFF",
        LINE: "#D9DBE9",
        LINE_HOVER: "#D9DBE9",
        BUTTON: {
          COLOR: "#fff",
          COLOR_HOVER: "#fff",
          BACKGROUND_COLOR: "transparent",
          BACKGROUND_COLOR_HOVER: "transparent",
          BORDER_COLOR: "#FFFFFF",
          BORDER_COLOR_HOVER: "#F8981C",
        },
      },
    },
  },
  FOOTER: {
    VARIANT1: {
      BACKGROUND: "#0B0E23",
      BACKGROUND_SECOND: "#0B0E23",
      TITLE: "#FFFFFF",
      TITLE_HOVER: "#FFFFFF",
      PARAGRAPH: "#FFFFFF",
      PARAGRAPH_HOVER: "#FFFFFF",
      LABEL: "#F8981C",
      LABEL_HOVER: "#F8981C",
      LINE: "#D9DBE9",
      LINE_HOVER: "#D9DBE9",
      BORDER_COLOR: "#D9DBE9",
      BORDER_COLOR_HOVER: "#D9DBE9",
    },
  },
  ANIMATION: {
    IMAGE: {
      FADEINTIME: "1",
    },
  },
  COLOR: {
    BLACKCOLOR: "#B45309",
    WHITECOLOR: "#FFFFFF",
    BODYCOLOR: "#0B0E23",
    DEFAULT_TEXT_COLOR: "#3C3C3C",
    HIGHLIGHT_COLOR: "#F8981C",
    AVTAR_BG: "#FFFFFF",
    AVTAR_ICON_COLOR: "#F8981C",
    /* Fallback ground under a full-bleed hero image, so the scrim never sits on white. */
    HERO_BG: "#0A0D24",
  },
  // Heading face Roboto Condensed (600/700/700 italic) and body face Hanken Grotesk
  // (400/500/600) are declared in libs/themes/src/lib/fonts/font.css. Each constant is a full
  // font stack so the system fallbacks apply while the web font loads.
  FONTNAMEPRIMARY: "'Roboto Condensed', 'Arial Narrow', Arial, sans-serif",
  FONTNAMESECONDARY: "'Hanken Grotesk', system-ui, sans-serif",
};

export default ThemeConstants;
